import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-fancy-checkbox',
  templateUrl: './fancy-checkbox.component.html',
  styleUrls: ['./fancy-checkbox.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FancyCheckboxComponent),
    multi: true
  }]
})
export class FancyCheckboxComponent implements OnInit, ControlValueAccessor {

  @Input() fancyLabel: string;
  @Input() fancyUnchecked: string;
  @Input() checkedLabel: string;
  @Input() unCheckedLabel: string;
  @Input() color: 'main' | 'danger' = 'main';

  updateValue: any;
  value: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  registerOnChange(fn: any): void {
    this.updateValue = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  toggleValue(){
    this.value = !this.value;
    console.log('Change to ' + this.value)
    this.updateValue(this.value);
  }

}
